import { useEffect, useState } from "react";
import Button from "../../components/Button";
import Spinner from "../../components/Spinner";
import Title from "../../components/Title";
import useAuthData from "../../hook/useAppData";
import { _formatDate } from "../../libs/dateUtils";
import "./index.scss";
import { IInvoiceUser } from "./models";
import { toastError } from "../../components/Toast";
import { Toaster } from "react-hot-toast";
import { ModalPopUp } from "../../components/ModalPopUp";
import { ContentModalNewInvoice } from "./components/ModalNewInvoice";
import { FilterRow } from "./components/FilterRow";
import { TableInvoice } from "./components/TableInvoice";
import { getInvoice } from "./service/service.dto";
import { uploadInvoice } from "./service";

export function UserInvoice() {
  const { userName, token } = useAuthData();
  const [needSpinner, setNeedSpinner] = useState(true);
  const [invoices, setInvoices] = useState<IInvoiceUser[]>();
  const [needNewInvoice, setNeedNewInvoice] = useState(false);

  useEffect(() => {
    getInvoices();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [invoices]);

  async function getInvoices() {
    const resultGetInvoices = await getInvoice({ token });
    const invoicesOrderByYearAndMonth = resultGetInvoices?.sort((a, b) => {
      const dateOne = a?.month + a?.year;
      const dateTwo = b?.month + b?.year;
      return dateOne > dateTwo ? -1 : 1;
    });

    setInvoices(invoicesOrderByYearAndMonth);
  }

  const handleFileClick = async (target, period: { year: string; month: string }) => {
    if (!target?.files[0]?.type?.includes("application/pdf")) return toastError("Esse arquivo não é um PDF!");
    const res = await uploadInvoice({ token, file: target.files[0], year: String(period.year), month: String(period.month)?.padStart(2, "0") });
    if (!res?.ok) return toastError("Não foi possível enviar o arquivo");
    return setTimeout(() => {
      return getInvoices();
    }, 1000);
  };

  const closeModalNewInvoice = async (get: boolean) => {
    if (!get) return setNeedNewInvoice(false);
    setTimeout(async () => {
      setNeedSpinner(true);
      await getInvoices();
      setNeedNewInvoice(false);
      setTimeout(() => {
        setNeedSpinner(false);
      }, 1500);
    }, 500);
  };

  return (
    <>
      <Toaster />
      <ModalPopUp title="Salvar Nota Fiscal no sistema" status={needNewInvoice} onClickCancel={() => closeModalNewInvoice(false)}>
        <ContentModalNewInvoice closeModal={closeModalNewInvoice} />
      </ModalPopUp>
      <Spinner status={needSpinner}>
        <div className="invoice-screen box-header">
          <Title classNameBox="mt-8" title={`Notas Fiscais - ${userName}`}>
            <Button onClick={() => setNeedNewInvoice(true)} className="bg-primary w-80 font-bold text-white px-2 uppercase">
              Adicionar Nota Fiscal
            </Button>
          </Title>
          {/* <FilterRow dateFrom={dateFrom} dateTo={dateTo} setDateFrom={setDateFrom} setDateTo={setDateTo} getInvoices={getInvoices} /> */}
          <div className="h-24"></div>
          <TableInvoice invoices={invoices} handleFileClick={handleFileClick} />
        </div>
      </Spinner>
    </>
  );
}
